import React, { useState, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import AddCircleOutlineOutlined from '@material-ui/icons/AddCircleOutlineOutlined';

import { Delete } from '@material-ui/icons';
import { Grid, TextField } from '@material-ui/core';
import cls from './step7.module.scss';

// import CurrencyHelper from '../../../helpers/Currency';
import constanteTitle from './DefaultTicketOptions';

import OfferPrice from './component/OfferPrice';
import Payment from './component/Payment';
import Confirm from '../../../components/Modals/Body/Confirm';

import IsShowModal from '../../../components/Modals/IsShowModal';

function Packages({
  langCildren,
  formValues,
  setTicketForm,
  control,
  register,
  errors,
  reset,
}) {
  const totalCurrency = (formValues && formValues.currency) || 'EUR';

  const { t } = useTranslation();
  // const locale = useSelector((state) => state.locale);
  const [indexValue, setIndex] = useState(false);
  const [dropPopular, setDropPopular] = useState([]);
  const totalPlaces = (formValues && formValues.places) || 0;
  useEffect(() => {
    reset({ packages: formValues.packages });
  }, [formValues.packages]);

  const [delModal, setDelModal] = useState(false);
  useMemo(() => {
    if (!formValues?.dropSelected?.length) {
      setTicketForm({ dropSelected: Object.keys(constanteTitle) });
    }

    let startDropPopular = [];
    if (formValues && formValues.dropSelected) {
      startDropPopular = formValues.dropSelected.map((item) => ({
        value: item,
        label: constanteTitle[item]?.lang[langCildren],
      }));
    }
    setDropPopular(startDropPopular);
  }, [formValues.dropSelected, langCildren]);

  const labelStoir = () => {
    const textHed = t('create.step7.mostPopular');
    const textInfo = (
      <span className={cls.span_label}>
        {t('create.step7.mostPopularInfo')}
      </span>
    );
    return (
      <span>
        {textHed} {textInfo}
      </span>
    );
  };

  const dropDown = (pl) => (
    <Select
      className={cls.add_popular_var}
      value=""
      onChange={(e) => {
        setTicketForm({
          packages: [
            {
              title: constanteTitle[e.target.value]?.lang,
              places: constanteTitle[e.target.value].places || pl,
              currency: totalCurrency,
              default: e.target.value,
              placesOfOffer: '',
              value: '',
            },
            ...formValues?.packages,
          ],
        });
      }}
      variant="outlined"
      displayEmpty
      renderValue={() => labelStoir()}
    >
      {dropPopular.map((el, key) => (
        <MenuItem value={el.value} button key={key}>
          {el.label}
        </MenuItem>
      ))}
    </Select>
  );

  return (
    <>
      {dropDown(totalPlaces)}
      {formValues?.submitFailed &&
        (!formValues?.packages || formValues.packages.length < 0) && (
          <div className={cls.error_packages}>
            {t('create.step7.errorPackages')}
          </div>
        )}
      <div className={cls.info_new_container}>
        {formValues.packages.map((packages, index) => {
          const { onChange: onChangePackages, ...resPackagesProps } = register(
            `packages.${index}.title.${langCildren}`,
            {
              required: t('form.validate.required'),
              minLength: {
                value: 10,
                message: t('form.validate.formMin', { min: '10' }),
              },
            },
          );
          return (
            <div key={index} className={cls.info_new}>
              <section className={`widget ${cls.box_package}`}>
                <Grid container spacing={2}>
                  <Grid item xs={8} md={10}>
                    <TextField
                      error={!!errors?.packages?.[index]?.title?.[langCildren]}
                      onChange={(e) => {
                        onChangePackages(e);
                        setTicketForm({
                          packages: formValues?.packages.map((i, ind) =>
                            ind === index
                              ? {
                                  ...i,
                                  title: {
                                    ...i.title,
                                    [langCildren]: e.target.value,
                                  },
                                }
                              : i,
                          ),
                        });
                      }}
                      label={`${t('create.step7.descr')} *`}
                      name={`packages.${index}.title.${langCildren}`}
                      placeholder={t('create.step7.description')}
                      fullWidth
                      autoComplete="off"
                      variant="outlined"
                      {...resPackagesProps}
                      helperText={
                        errors?.packages?.[index]?.title?.[langCildren]
                          ? errors?.packages?.[index].title?.[langCildren]
                              .message
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={4} md={2}>
                    <Button
                      className={cls.button}
                      variant="contained"
                      color="secondary"
                      error
                      onClick={(e) => {
                        setIndex(index);
                        e.preventDefault();
                        e.stopPropagation();
                        setDelModal(true);
                      }}
                    >
                      <Delete />
                    </Button>
                  </Grid>
                </Grid>
                <OfferPrice
                  index={index}
                  control={control}
                  formValues={formValues}
                  register={register}
                  setTicketForm={setTicketForm}
                  errors={errors}
                />
                <Payment
                  index={index}
                  formValues={formValues}
                  register={register}
                  control={control}
                  setTicketForm={setTicketForm}
                  errors={errors}
                />
              </section>
            </div>
          );
        })}
      </div>
      <div className={cls.add_info}>
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            setTicketForm({
              packages: [
                {
                  currency: totalCurrency,
                },
                ...formValues?.packages,
              ],
            });
          }}
          type="button"
        >
          <AddCircleOutlineOutlined />
          <span
            className={
              dropPopular.length < 1
                ? cls.add_info_light
                : cls.add_info_non_active
            }
          >
            {t('create.step7.add')}
          </span>
        </button>
        <IsShowModal
          deed={delModal}
          closeDeed={() => setDelModal(false)}
          title={`${t('Pay.deleteItem')} ${indexValue + 1}`}
          modalContent={
            <Confirm
              closeAction={() => setDelModal(false)}
              action={() => {
                setTicketForm({
                  packages: formValues.packages.filter(
                    (_i, ind) => indexValue !== ind,
                  ),
                });
              }}
            />
          }
        />
      </div>
    </>
  );
}

Packages.propTypes = {
  langCildren: PropTypes.string.isRequired,
  errors: PropTypes.shape({}),
  formValues: PropTypes.shape({}).isRequired,
  setTicketForm: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  control: PropTypes.shape({}).isRequired,
  reset: PropTypes.func.isRequired,
};

Packages.defaultProps = {
  errors: null,
};

export default Packages;
